import { ProtectionDetailsUpsellModalData } from '../../models/protection-details/protection-details-upsell-modal-data.interface';
import { RegistrationSystemCode } from '../../models/registration/registration-system-code.enum';
import { mockRegisteredItemProductDetailsAnnual } from '../registered-item/registered-item-product-details-annual.mock';
import { mockRegisteredItemProductDetails } from '../registered-item/registered-item-product-details.mock';
import { mockRegisteredItem } from '../registered-item/registered-item.mock';
import { mockCmsProtectionDetailsUpsellModal } from './cms-protection-details-upsell-modal.mock';

export const mockProtectionDetailsUpsellModalData: ProtectionDetailsUpsellModalData =
  {
    cmsProtectionDetailsUpsellModal: mockCmsProtectionDetailsUpsellModal,
    merchandiseBrand: mockRegisteredItem.merchandiseBrand,
    annualPlansEnabled: false,
    prepaySubscriptionVariant: null,
    promotionalPriceEnabled: true,
    registeredItemHasAnnualPayment: false,
    registeredItemProductDetails: mockRegisteredItemProductDetails,
    registeredItemAnnualProductDetails: mockRegisteredItemProductDetailsAnnual,
    registeredItemProducts: mockRegisteredItem.products,
    systemCode: RegistrationSystemCode.InternetProductRegistration,
  };
